import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs'
import type { BreadcrumbItemType } from '@/components/breadcrumbs/BreadcrumbItem'
import type { ExternalStorageProvider } from '@/constants/constants-external-storage'
import type { DriveSourceViewMode } from '@/user_files/drive/types'
import { DmsSourceToggle } from '@/user_files/external-storage/components/DmsSourceToggle'
import { FolderBreadcrumbs } from '@/user_files/folders/components/FolderBreadcrumbs'

export type DriveSourceHeaderProps = {
  viewMode: DriveSourceViewMode
  onChangeViewMode: (mode: DriveSourceViewMode) => void
  /** Whether this matter has a DMS source to switch to at all — synced, unsynced, or errored. */
  showSourceToggle: boolean
  externalBreadcrumbItems: BreadcrumbItemType[]
  /** Provider the toggle labels its DMS option with: the synced one, or the connected one when no folder is synced yet. */
  dmsProvider: ExternalStorageProvider | null
}

export function DriveSourceHeader({ viewMode, onChangeViewMode, showSourceToggle, externalBreadcrumbItems, dmsProvider }: DriveSourceHeaderProps) {
  return (
    <div className="flex min-w-0 items-center gap-3.5">
      {showSourceToggle && <DmsSourceToggle provider={dmsProvider} viewMode={viewMode} onChangeViewMode={onChangeViewMode} />}
      {/* -ml-2 offsets the breadcrumb items' internal px-2 padding so text aligns flush with the container edge */}
      <div className="-ml-2 min-w-0">
        {viewMode === 'external' ? (
          <Breadcrumbs items={externalBreadcrumbItems} maxItems={3} maxLabelLength={20} maxActiveLabelLength={100} textSize="base" persistFirstItem />
        ) : (
          <FolderBreadcrumbs onNavigate={() => onChangeViewMode('matter')} />
        )}
      </div>
    </div>
  )
}
